import RightArrow from "@/mocks/assets/rightArrowWhite.svg";
import { PrimaryButton } from "../button/primaryButton";
import Image from "next/image";
import Link from "next/link";

const MerchantLinkButton = ({ merchantColor, uri, text }: any) => (
  <Link href={uri}>
    <PrimaryButton
      className={"text-sm text-white flex items-center"}
      style={{ backgroundColor: merchantColor }}
    >
      <span className="mr-2">{text}</span>
      <Image src={RightArrow} alt="rightarrow" />
    </PrimaryButton>
  </Link>
);

export default MerchantLinkButton;
